module.exports = __webpack_public_path__ + "static/planing-fc6d6617061b4ef6d64cac474c43bd46.svg";